<template>
    <div class="trz_leave_settings">

        <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">

            <div class="row ">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            Leave Year/Contract Date Range From {{ startDate }} To {{ endDate }}
                        </div>

                        <div class="card-body " v-if="available.length > 0">
                            <div class="row">
                                <div class="col-sm-4">
                                  <b-input-group class="date-range-picker d-flex flex-row align-items-end justify-content-start" style="margin-bottom: 2px;">
                                    <b-form-group label="Leave Date" class="mb-0" label-for="leave_date">
                                      <b-input-group class="mb-0">
                                        <b-form-input @input="loadData(date)" id="leave_date" v-model="date" type="text" placeholder="YYYY-MM-DD" autocomplete="off"/>
                                        <b-input-group-append>
                                          <b-form-datepicker @input="loadData(date)" id="day_two" button-only right locale="en-US" v-model="date"/>
                                        </b-input-group-append>
                                      </b-input-group>
                                    </b-form-group>
                                  </b-input-group>

                                </div>

                                <div class="col-sm-4">
                                    <b-form-group id="attendance_date-group" label="Available Dates"
                                        class="required-field" label-for="attendance_date" style="width: 100%;">
                                        <b-form-select id="attendance_date" name="attendance_date"
                                            v-model="fdata.attendance_assignment_id" v-validate="{ required: true }"
                                            :options="available" :state="validateState('attendance_date')"
                                            aria-describedby="attendance_date-feedback" data-vv-as="Available Dates"
                                            style="width: 100%;"></b-form-select>
                                        <b-form-invalid-feedback id="attendance_date-feedback">{{
                                            veeErrors.first('attendance_date') }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>

                                <div class="col-sm-4">
                                    <b-form-group id="status-group" label="Leave Status" class="required-field"
                                        label-for="status" style="width: 100%;">
                                        <b-form-select id="status" name="status" v-model="fdata.status"
                                            v-validate="{ required: true }" :options="status"
                                            :state="validateState('status')" aria-describedby="status-feedback"
                                            data-vv-as="Leave Status" style="width: 100%;"></b-form-select>
                                        <b-form-invalid-feedback id="status-feedback">{{ veeErrors.first('status')
                                            }}</b-form-invalid-feedback>
                                    </b-form-group>
                                </div>
                              <div class="col-md-12">
                                <b-list-group>
                                  <b-list-group-item v-for="item in currentAssignments" :key="item.id" v-b-tooltip.hover.top="'Tap to select'" button
                                      :active="fdata.leave_assignment_id == item.id" @click="fdata.leave_assignment_id = item.id">
                                    <div class="d-flex justify-content-between align-items-center">
                                      <div class="d-flex flex-row">
                                        <div class="mr-3" style="width: 35px; height: 35px; border-radius: 50%;" :style="{ background: item.shift.color }"></div>
                                        <div>
                                          <strong :class="{ 'text-white': fdata.leave_assignment_id == item.id }">{{ item.shift.name }}</strong>
                                          <div class="text-muted small">{{ item.shift.start_time }} - {{ item.shift.end_time }}</div>
                                        </div>
                                      </div>

                                      <small class="text-muted">{{ item.period_date }}</small>
                                    </div>
                                  </b-list-group-item>
                                </b-list-group>
                              </div>
                              <div class="col-12">
                                <b-form-group id="reason-group" label="Reason" class="required-field"
                                              label-for="reason">
                                  <b-form-textarea id="reason" name="reason" rows="3" max-rows="6" v-model="fdata.reason" v-validate="{ required: true }"
                                                   :state="validateState('reason')" aria-describedby="reason-feedback" data-vv-as="Reason"></b-form-textarea>
                                  <b-form-invalid-feedback id="reason-feedback">{{ veeErrors.first('reason')}}</b-form-invalid-feedback>
                                </b-form-group>
                              </div>
                            </div>

                            <div class='mt-2'>
                                <div class="clearfix">
                                    <div class="float-left"><b-button @click="saveLeave()">Save</b-button></div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body " v-else>No available dates.</div>
                    </div>
                </div>
            </div>

            <div class="card mt-4">

                <div class="col-sm-12">
                    <div class="card-header table-head">Allowed Leaves</div>
                    <div class="card-body ">
                        <table class="table">
                            <thead>
                                <tr class="table-head">
                                    <th>Leave Date</th>
                                    <th>Used Attendance Date</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="table-row hover-bg" v-for="leave in compensatory_leave_list" :key="leave.id">
                                    <td>{{ leave.leave_date }}</td>
                                    <td>{{ leave.attendance_date }}</td>
                                    <td>{{ status[leave.status].text }}</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>

            </div>
        </b-overlay>

    </div>
</template>
<script>

import moment from 'moment'

export default {

    mounted() {
        this.$nextTick(() => {
            this.$validator.validate('leave_date');
        });
    },
    props: ['employee_id'],
    components: {

    },
    data() {
        const today = moment().format('YYYY-MM-DD');

        return {

            startDate: null,
            endDate: null,
          date: '',

            showoverlay: false,

            fdata: { leave_assignment_id: today,attendance_assignment_id: today, status: 0, reason: '' },
          attendance_date: '',
            compensatory_leave_list: [],
            available: [],
            currentAssignments: [],
            selectedAssignment: null,

            blankmsg: '',

            status: [
                { text: 'Applied', value: '0' },
                { text: 'Approved', value: '1' },
                { text: 'Declined', value: '2' },
            ],


        }
    },
    methods: {
      toggle(id) {
        let index = this.selectedAssignments.indexOf(id);

        if (index == -1) {
          this.selectedAssignments.push(id);
        } else {
          this.selectedAssignments.splice(index, 1);
        }
      },
      loadData(date){
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
          return false;
        }
        axios.get(this.$api_url + '/leave-attendance/assignment/details', {
          params: {
            date: date
          }
        }).then((response) => {
          this.currentAssignments = response.data;
          this.selectedAssignments = [];
        }).catch(e=>this.serverError(e));
      },

        getLeaves: function () {
            this.showoverlay = true;
            axios.get(this.$api_url + '/leave-attendance/compensatory-leave-list', {
                params: {
                    employee_id: this.employee_id
                }
            }).then(function (response) {

                if (response.data.length != 0) {

                    this.compensatory_leave_list = response.data.compensatory_leave_list;

                    this.available = response.data.available;


                    this.startDate = response.data.leave_limit_start_date;
                    this.endDate = response.data.leave_limit_end_date;


                    if (this.compensatory_leave_list.length == 0) {
                        this.blankmsg = 'Looks like no leave applied for the employee yet.';
                    }

                }

                this.showoverlay = false;

            }.bind(this));

        },
        saveLeave() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                this.showoverlay = true;

                let formData = new FormData();
                for (let [key, value] of Object.entries(this.fdata)) {
                    formData.append(key, value);
                }
                axios.post(this.$api_url + '/leave-attendance/compensatory-leave-save', formData)
                    .then(response => {
                        this.$bvToast.toast(response.data.message || 'Saved successfully.', {
                            title: response.data.toast_title || 'Success',
                            variant: response.data.toast_variant || 'success',
                            solid: true
                        });

                        if (response.data.status != 200) {
                            return;
                        }

                        this.getLeaves();
                        this.$emit('childToParent');
                    })
                    .catch(error => {
                        const message =
                            error.response && error.response.data && error.response.data.message
                                ? error.response.data.message
                                : 'An unexpected error occurred.';

                        this.$bvToast.toast(message, {
                            title: 'Error',
                            variant: 'danger',
                            solid: true
                        });
                    })
                    .finally(() => {
                        this.showoverlay = false;
                    });
            });
        }
        ,
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },

    },
    created: function () {

        this.getLeaves();
    },
    computed:
    {

    }
}
</script>
